import {ajax, getRequestUrl, formatData, uploadImg} from "./request";
// 群组管理 列表
function groupList(data, method) {
  return ajax('post', getRequestUrl('/api/GroupChat/groupList'), data, {
    method,
  });
}
// 群组管理 群详情
function groupDetail(data, method) {
  return ajax('post', getRequestUrl('/api/GroupChat/groupDetail'), data, {
    method,
  });
}
// 群组管理 --群聊黑名单
function groupChatBlack(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/groupChatBlack'), data)
}
// 群组管理 --删除黑名单
function groupChatBlackDelete(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/groupChatBlackDelete'), data)
}
// 群组管理 --修改群信息
function reviewResetGroup(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/resetGroupInformation'), data)
}
// 群组管理 --封禁、解禁群组
function groupBanSet(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/groupBanSet'), data)
}

// 群组管理 --群成员列表
function groupMember(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/groupMember'), data)
}

// 群组管理 --解散群组
function disbandGroup(data) {
  return ajax('post', getRequestUrl('/api/GroupChat/disbandGroup'), data)
}

export default {
  groupList,
  groupDetail,
  groupChatBlack,
  groupChatBlackDelete,
  reviewResetGroup,
  groupBanSet,
  groupMember,
  disbandGroup,
}



// WEBPACK FOOTER //
// ./src/js/group.js